import get from 'lodash/get'
import uniqBy from 'lodash/uniqBy'
import i18n from '@/plugins/vue-i18n'
import { joinBySymbol } from '@/helpers/filters'

export function renderValueByKey(value, key) {
  return renderValue(get(value, key))
}

export function renderArrayOfObjectsByKey(value, key){
  if(!value.length) return ''
  return value.reduce((newArr, item) => {
    if(Array.isArray(key)){
      let newVal = []
      key.forEach(el => {
        if(el.includes('.')){
          let newItem = item
          el.split('.').map(el => newItem = newItem[el])
          if(newItem === null) return
          newVal.push(newItem)
        }
        else if (item[el]) {
          newVal.push(item[el])
        }
      })
      newArr.push(newVal.join(' '))
      return newArr
    }
    if(key.includes('.')){
      let newItem = item
      key.split('.').map(el => newItem = newItem[el])
      newArr.push(newItem)
    }
    else if (item[key]) {
      newArr.push(item[key])
    }
    return newArr
  }, [])
  .join(', ')
}
// long lists in tooltips: unique items, first `limit` of them, then "and N more"
export function renderLimitedList(value, key, limit = 20) {
  if (!value?.length) return ''
  const items = uniqBy(value, item => item.id ?? get(item, key))
    .map(item => get(item, key))
    .filter(Boolean)
  if (items.length <= limit) return items.join(', ')
  return `${items.slice(0, limit).join(', ')} ${i18n.t('base.limitText', { count: items.length - limit })}`
}
export function renderValue(value) {
  return value || '-'
}
export function renderValueYesNo(value) {
  return value ? i18n.tc('base.yes') : i18n.tc('base.no')
}
export function renderActive(value) {
  return value ? i18n.tc('base.listStatusActive') : i18n.tc('base.listStatusInactive')
}
export function renderValueJoinBySymbol(arr, symbol = ', ') {
  return joinBySymbol(arr, symbol)
}

export function numberWithSpaces(value, returnValue = '') {
  if (!value && value !== 0) return returnValue;
  const [integerPart, decimalPart] = value.toString().split('.');
  const groupedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return decimalPart !== undefined ? `${groupedInteger}.${decimalPart}` : groupedInteger;
}

export function removeCents(value){
  return value ? value.toString().split('.')[0] : value
}

export const noDataPagination = {
  items: [], pagination: {
    currentPage: 1,
    limit: 1,
    total: 0,
    maxPageNumber: 0,
  }
}